import { Container } from '@crehana/ui';
import { Loadable } from '@crehana/web';

import { DashboardErrorView } from '@/views/UserDashboard/components';

import BootcampSkeleton from './components/BootcampSkeleton';

const LazyBootcamps = () => (
  <Loadable
    Loader={
      <Container type="dashboard">
        <BootcampSkeleton />
      </Container>
    }
    ErrorFallback={
      <Container type="dashboard">
        <DashboardErrorView defaultConnectionError supportsDarkMode />
      </Container>
    }
    module={() =>
      import(/* webpackChunkName: "user-dashboard-degrees" */ './Bootcamps')
    }
  />
);
export default LazyBootcamps;
